<template>
  <div class="ranking-header">
    <div class="ranking-header-content">
      <div>
        <h1>
          <i class="icofont-medal-sport"></i>
          Ranking Resultado Cofinanciamento Federal da APS
        </h1>

        <p>
          Classificação baseada no Desempenho, que prioriza a superação de todas
          as equipes: saindo da classificação
          <strong style="color: red">Regular</strong> em direção à classificação
          <strong style="color: blue">Ótimo</strong>, tanto nos componentes
          quanto nos indicadores.
        </p>

        <hr />

        <p class="note">
          <strong>
            Clique nos 3 pontinhos (<i class="icofont-navigation-menu"></i>)
          </strong>
          ao lado do município para ver mais informações.
        </p>

        <p class="mb-0">
          <strong>Fonte</strong>:
          <a href="https://siaps.saude.gov.br/publico" target="_blank">Siaps</a
          >, jun. 2026.
        </p>
      </div>
      <modal-informacao
        :isIframe="true"
        urlIframe="https://doc.clickup.com/9011510980/d/8cj1fp4-1731/rankinggeral"
        iframe-width="100%"
        iframe-height="615px"
        pageIdentifier="cofinanciamento-ranking-geral"
      ></modal-informacao>
    </div>

    <!-- <button class="btn-export" @click="$emit('exportar')">
      <i class="fas fa-download"></i>
      Exportar Ranking
    </button> -->
  </div>
</template>

<script>
import ModalInformacao from '@/components/ModalInformacao.vue'

export default {
  name: 'RankingHeader',
  components: {
    ModalInformacao,
  },
}
</script>

<style scoped>
.ranking-header {
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.ranking-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

h1 {
  margin: 0;
  color: #1e3a8a;
  font-size: 24px;
  font-weight: 800;
}

h1 i {
  margin-right: 8px;
}

p {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.btn-export {
  background: #16a34a;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 11px 18px;
  font-weight: 700;
  cursor: pointer;
}

.btn-export i {
  margin-right: 8px;
}

@media (max-width: 768px) {
  .ranking-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
